module.exports = __webpack_public_path__ + "img/9-large.00524465.png";